export const numberFormatter = {
  toStringWithDecimals: (
    value?: number | null,
    minDigits = 2,
    maxDigits = 2,
    locale = "de-DE"
  ): string => {
    if (value === null || value === undefined || Number.isNaN(value)) return "-";

    return value.toLocaleString(locale, {
      minimumFractionDigits: minDigits,
      maximumFractionDigits: maxDigits,
    });
  },

  toStringWithAmount: (
    value: number | null | undefined,
    codCurrency = "",
    fractionDigits = 2,
    locale = "de-DE"
  ): string => {
    if (value === null || value === undefined || Number.isNaN(value)) return "-";

    const amount = value.toLocaleString(locale, {
      minimumFractionDigits: fractionDigits,
      maximumFractionDigits: fractionDigits,
    });

    return codCurrency ? `${codCurrency} ${amount}` : amount;
  },

  toStringAsCurrency: (
    value: number | null | undefined,
    codCurrency = "ARS",
    locale = "es-AR"
  ): string => {
    if (value === null || value === undefined || Number.isNaN(value)) return "-";

    return new Intl.NumberFormat(locale, {
      style: "currency",
      currency: codCurrency,
    }).format(value);
  },

  formatPrice: (price: number): string => {
    return new Intl.NumberFormat('es-AR', {
      style: 'currency',
      currency: 'ARS',
      minimumFractionDigits: 0,
    }).format(price);
  }
};
